import { render, staticRenderFns } from "./ExportFile.vue?vue&type=template&id=c117c27c&scoped=true&"
import script from "./ExportFile.vue?vue&type=script&lang=js&"
export * from "./ExportFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c117c27c",
  null
  
)

export default component.exports